import { Button } from "@material-ui/core";
import Config from "Config";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { isEmpty, isNotEmpty } from "../../Utils";
import { addAttachment } from "../../redux/action";
import { getAttachment } from "../../redux/selector";

export function Downloadable({ fileName, fileId, singerName, disabled = false }) {
    const dispatch = useDispatch();
    const [downloadUrl, setDownloadUrl] = useState("");
    const fileContent = useSelector(getAttachment(fileId));
    const downloadLink = useRef(null);

    useEffect(() => {
        if (isEmpty(fileContent)) {
            setDownloadUrl("");
        } else {
            setDownloadUrl(fileContent ? URL.createObjectURL(fileContent) : "");
        }
        return () => {
            URL.revokeObjectURL(downloadUrl);
        };
    }, [fileContent]);

    const onDownload = () => {
        if (isNotEmpty(fileContent)) {
            downloadLink.current.click();
        } else {
            const option = {
                url: `${Config.CONTENT_PATH}/attachment/${fileId}`,
            };
            dispatch(send("GET_ATTACHMENT", option))
                .then((res) => res.blob())
                .then((fileContent) => {
                    dispatch(addAttachment({ [fileId]: fileContent }));
                    setTimeout(() => {
                        downloadLink.current.click();
                    }, 500);
                });
        }
    };

    return (
        <>
            <a
                ref={downloadLink}
                href={downloadUrl}
                download={fileName}
                aria-label={fileName}
            >
                <i className="hidden">{fileName}</i>
            </a>

            <Button
                style={{ textTransform: "none", textAlign: "left" }}
                variant="text"
                disabled={disabled}
                onClick={onDownload}
            >
                <span>{isNotEmpty(singerName) ? singerName : fileName}</span>
            </Button>
        </>
    );
}
